/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ArrowDownIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.30454 4L1.5 4.80454L6 9.30453L10.5 4.80454L9.69545 4L6 7.69543L2.30454 4Z"
        fill={color}
      />
    </svg>
  );
};
